import { Typography } from 'src/ui/common/atoms/typography';
import styled from 'styled-components';

export const StyledDescription = styled(Typography)`
    color: ${({ theme }) => theme.colors.warmBlack};

    & + * {
        margin-top: 10px;
    }
`;
